define('SageDotCom/Components/Listing/PageListing',['jquery',
    'SageDotCom/DataLayer/tealium',
    'SageDotCom/DataLayer/Util/trackingHelper',
    'SageDotCom/DataLayer/Events/searchSelection',
    'SageDotCom/DataLayer/Events/searchRefinement',
    'SageDotCom/DataLayer/Events/bodySelect',
    'SageDotCom/Utility/sanitizer'],
    function ($, tealium, trackingHelper, searchSelection, searchRefinement, bodySelectEvent, sanitizer) {
    function PageListing(scope) {
        // split query string params into a format for tealium
        // ?page=5&month=4,3&year=2017 will equate to: 'page: 5; month: 4,3; year: 2017;'
        function GetRefinements(url) {
            var refinements = '';
            
            var parser = document.createElement('a');

            if (!sanitizer.containsHTML(url)) {
                parser.href = url || window.location.href;
            } else {
                return;
            }


            
            var query = parser.search.substring(1);
            var vars = query.split('&').filter(function (v) { return v !== '' }); // split and remove empty values
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                refinements += pair[0] + ": " + decodeURIComponent(pair[1]) + "; ";
            }

            return refinements.trim().replace(/\;$/, ''); // trim and remove any trailing semi colon
        }

        $("a, input:radio, input:checkbox", scope).not(".pagination-container a").click(function (event) {
            var eventObj = searchSelection.GenerateEventMetadata(event.currentTarget, null, GetRefinements());
            tealium.event(eventObj);
        });

        $(".pagination-container a", scope).click(function(el) {
            var eventObj = searchRefinement.GenerateEventMetadata(event.currentTarget, null, GetRefinements(event.currentTarget.href), window.location.href);
            tealium.event(eventObj);
        });

        $(".js-show-all", scope).click(function (el) {
            var eventSchema = bodySelectEvent.GenerateEventMetadata(scope, 'expand');
            tealium.event(eventSchema);
        });

        trackingHelper.registerTracking(scope, searchSelection.getName());
        trackingHelper.registerTracking(scope, searchRefinement.getName());
    }

    return function initPageListing(args) {
        return args.IsExperienceEditorEditing ? null : new PageListing(args.scope);
    }
});
